import React, { useState } from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import './ProjectTabs.css'
import { useLazyGetProjectTaskByIdQuery } from '../../../services/EndPointsApis';
import DateComp from '../../../core/common/dateComponent/DateComp';
import NoRecordFound from '../../../core/common/noRecord/NoRecordFound';


type CheckedState = {
  id: string | null;
  isChecked: boolean;
};


const RecentProjectTasks = ({ setselectedId, selectedId, getallpTasks }: any) => {

  const [checkedState, setCheckedState] = useState<CheckedState>({ id: null, isChecked: false });

  const [expandedTask, setExpandedTask] = useState<string | null>(null);
  const handleLinkClick = (id: string) => {
    setExpandedTask((prevState) => (prevState === id ? null : id));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    e.stopPropagation();
    setCheckedState((prevState) => {
      const newCheckedState = {
        id,
        isChecked: prevState.id === id ? !prevState.isChecked : true,
      };

      // Set the selected ID when the checkbox is checked
      if (newCheckedState.isChecked) {
        setselectedId(id);
      } else {
        setselectedId([]);
      }

      return newCheckedState;
    });
  };

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="task-wrapper mt-2">
            <Link
              to="#"
              className="task-accordion"
              data-bs-toggle="collapse"
              data-bs-target="#recent"
            >
              <h4 className='color-red'>
                Recent Tasks
              </h4>
            </Link>
            {getallpTasks?.result.length > 0 ? (
              <div className="tasks-activity show tasks w-100 collapse" id="recent">
                {getallpTasks?.result?.map((task: any) => (
                  <ul key={task.taskId}>
                    <div className="task-checkbox">
                      <label className="checkboxs">
                        <input
                          type="checkbox"
                          checked={checkedState.id === task.taskId && checkedState.isChecked}
                          onChange={(e) => handleCheckboxChange(e, task.taskId)}
                        />
                        <span className="checkmarks checkcss" />
                      </label>
                    </div>
                    <ul>
                      <Link
                        to="#"
                        className="task-wrap pending"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapseExample${task.taskId}`}
                        id={task.taskId}
                        onClick={() => handleLinkClick(task.taskId)}
                      >
                        <div className="task-info">
                          <p>{task.title}</p>
                          <p className='text-muted'>created by</p>
                          <p>{task.lst_AssignedTo.value}</p>
                          <p className='text-muted'>at</p>
                          <p>{<DateComp formattedDate={task.startDate} />}</p>
                        </div>
                        <div className="task-actions">
                          <ul>
                            <li className="task-time d-flex gap-2">
                              <p className='mb-0'><b>Assigned To:</b> {task.lst_AssignedTo.value}</p>
                              <p className="badge badge-tag badge-success-light mb-0">
                                <i className='fa fa-circle fs-10'></i> {task.lst_PriorityCode.value}
                              </p>
                              <p className="badge bg-soft-gray mb-0">
                                {task.lst_ProjectTaskStatus.value}
                              </p>
                            </li>
                          </ul>
                        </div>
                      </Link>
                      <div
                        className={`collapse ${expandedTask === task.taskId ? 'show' : ''}`}
                        id={`collapseExample${task.taskId}`}
                      >
                        <p><b>Description:</b> {task.description}</p>
                      </div>
                    </ul>
                  </ul>
                ))}
              </div>
            ) : (
              <div className='text-center'>
                <NoRecordFound />
              </div>
            )
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default RecentProjectTasks;
